(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name bidding.controller:BiddingCtrl
   *
   * @description
   *
   */
  angular
    .module('bidding')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('BiddingCtrl', BiddingCtrl);

  function BiddingCtrl(EventManagerService,ManageUserServices,BiddingService,MessageService,PopupManager,applicationConstants,CommonLogicService,TabService,$sce, CommonMasterData, crewScheduleService) {
	  	var vm = this;
    	vm.ctrlName = 'BiddingCtrl';

    	vm.model = {
    		createPanelToggle : false,
        	searchOnGoing : false,
        	searchPanelToggle:true,
        	initialSearchDone: false,
        	searchCriteria:{
        		cycle : null,
            	crewGroup : null,
            	crewBase : null,
            	fleetType : null,
            	pageSize : null,
            	startPosition : null,
            	crewType :null,
            	crewName :null,
            	crewId :null,
            	reqType : {reqTypeCode:'ALL'}
             },
             masterList:{
            	 cycles : [],
            	 fleetTypes : [],
            	 crewBases : [],
            	 crewGroups : [],
            	 crewTypes : [],
            	 crewListInSearchPanel : [],
            	 crewListInCreateReqPanel: [],
            	 durationTypes : [],
            	 departureTypes : [],
            	 patternNames : [],
            	 requestPriorities : [],
            	 reqTypes : [{reqTypeCode:'ALL'},{reqTypeCode:'OFF'},{reqTypeCode:'VUNP'},{reqTypeCode:'PATTERN'}],

             },
             biddingDetails : [],
             selectedViewMode : false,
             viewType : 'W',
             cycleInfo : null,
             isElasticLoadingVisible:false,
             isBottomTimeLineOpen : false,
             selectedBidRequest : null,
             strReqPriority : null,
             isFullScreen : false,
             reportUrl:null,
             isMandatoryFieldEmpty : false

     	};

    	EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    	EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.RESET_BOTTOM_LINE_OPENED_FLAG, setBottomLineOpenedFlag);

    	EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.SEARCH_BIDDING_INFO,searchBiddings);

    	EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.SEARCH_BIDDING_WITH_SEARCH_OPTIONS, searchBiddingsAfterApprove);

    	EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.RESET_SEARCH_RESULT,resetDataCollection);

    	EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.RESET_SELECTED_CREW_BID, resetSelectedBid);

    	EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.SAVE_MAX_CREW_BIDDING, saveMaxCrewBiddingDetails);

    	if($(".tabbed-view-container").height() == 0)
        	$(".tabbed-view-container").height(80);

        var height=($("header").height() + $(".tabbed-view-container").height())+"px";
    	$(".canvas").css("top", height);

    	vm.changeEditorField = function(flag){
    		switch (flag) {
			case "CREW_TYPE_SEARCH":
				searchCrewNamesInSearchPanel();
				break;
			case "CREW_TYPE_CRP":
				searchCrewNamesInCreateRequestPanel();
				searchPatternNames();
				break;
			case "REQUEST_DATE":
				searchPatternNames();
				break;
			case "CYCLE":
				setPriorityString();
				break;
			case "CREW_NAME":
				vm.model.searchCriteria.crewId = vm.model.searchCriteria.crewName.crewId;
				break;
			default:
				break;
			}
    	}

    	vm.onClickFullScreenIcon = function(){
    		vm.isFullScreen = !vm.isFullScreen;
    		EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.FULL_SCREEN, vm.isFullScreen);
    	}

    	vm.clickOnAddRequest = function(){
    		vm.model.createPanelToggle = true;
    		vm.model.selectedBidRequest = BiddingService.getNewBidRequest();
    		EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.CLOSE_BOTTOM_LINE);
    	}

    	vm.clickOnAddRequestClose = function(){
    		vm.model.createPanelToggle = false;
    	}

		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		vm.searchByOptions = function(){
		  if(!validateMandatoryFeilds()){
          vm.model.isMandatoryFieldEmpty =  true;
		    return false;
      }
			if(!vm.model.searchOnGoing){
				vm.model.initialSearchDone = true;
				vm.model.isBottomTimeLineOpen = false;
				vm.model.searchOnGoing = true;
				if(document.querySelector('.right-section') != null) {
					document.querySelector('.right-section').scrollTop = 0;
				}
				vm.model.biddingDetails = [];
				vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
				showLoader(true);
				resetApproveLaterTimeLine();
				setViewType();
				setDefault();
				drawTimeLine();
				searchBiddings();
			}
		}

		vm.viewOptionChange = function(){
			setViewType();
			if(vm.model.initialSearchDone){
				drawTimeLine();
			}
		}

		vm.createNewRequest = function(){
			createNewRequest();
		}

		vm.setRequestPriorities = function(){
			setPriorityString();
		}

		vm.generateReport = function(){
			getBiddingReport();
		}

		vm.navigateToConfigDistributionPage = function(){
			TabService.gotoTab('configDistribution');
		}

		function setPriorityString(){

			if(vm.model.searchCriteria.cycle == null){
				vm.model.strReqPriority = "";
			}else{
				vm.model.strReqPriority = vm.model.searchCriteria.cycle.crewGroupCode;
			}

		}

		function setBottomLineOpenedFlag(isBottomLineOpened){
			vm.model.isBottomTimeLineOpen = isBottomLineOpened;
		}

		function searchBiddingsAfterApprove(){
			if(!vm.model.searchOnGoing){
				vm.model.initialSearchDone = true;
				vm.model.searchOnGoing = true;
				vm.model.biddingDetails = [];
				showLoader(true);
				resetApproveLaterTimeLine();
				setViewType();
				setDefault();
				drawTimeLine();
				searchBiddings();
			}
		}

		function resetApproveLaterTimeLine(){
			EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.CLEAR_BOTTOM_LINE);
		}

		function searchBiddings(){
				var searchParams = vm.model.searchCriteria;
				vm.model.cycleInfo = vm.model.searchCriteria.cycle;
				BiddingService.searchCrewBiddingDetails(searchParams, function(biddingDetails,startPosition){
						 addBiddingDetailsData(biddingDetails);
						 vm.model.searchCriteria.startPosition = startPosition;
						 vm.model.searchPanelToggle = false;
						 drawCrewBiddings();
						 showLoader(false);
						 vm.model.searchOnGoing = false;
					}, function(error){
						MessageService.error(error);
					}
				);
		}

		function drawTimeLine(){
			vm.model.cycleInfo = vm.model.searchCriteria.cycle;
			var viewData = {cycleInfo :vm.model.cycleInfo, viewType :vm.model.viewType };
			EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.DRAW_TIME_LINES,viewData);
		}

		function drawCrewBiddings(){
			EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.DRAW_BIDDING_INFO,vm.model.biddingDetails);
		}

		function setViewType(){
			vm.model.viewType = !vm.model.selectedViewMode ? 'W':'M';
		}

		function getNextSetOfRecords() {
            vm.model.isElasticLoadingVisible = true;
            if(!vm.model.searchOnGoing){
            	vm.model.searchOnGoing = true;
            	searchBiddings();
            }
        }

		function showLoader(flag) {
			EventManagerService.notifyEventListeners(
					EventManagerService.EVENT.SHOW_HIDE_LOADING, {
						flag : flag,
						target : 'bidding',
						animationName : 'crewing-loader'
					});
		}

		function validateMandatoryFeilds(){
		  if(!!!vm.model.searchCriteria.crewType && !!!vm.model.searchCriteria.crewId ){
		    return false;
      }
      return true;
    }

		function addBiddingDetailsData(biddingData){
			angular.forEach(biddingData, function (crewBidding) {
                vm.model.biddingDetails.push(crewBidding);
            });
            vm.model.isElasticLoadingVisible = false;
		}

		function setDefault() {
        	vm.model.searchCriteria.pageSize = 1000;
            vm.model.searchCriteria.startPosition = 1;
            vm.model.selectedBidRequest = BiddingService.getNewBidRequest();
            setViewType();
        }

		function resetDataCollection(){
			vm.model.biddingDetails = BiddingService.resetDataCollection(vm.model.biddingDetails);
		}

		function resetSelectedBid(selectedBid){
			vm.model.biddingDetails = BiddingService.resetSelectedBid(vm.model.biddingDetails,selectedBid);
			drawCrewBiddings();
		}

    function searchCrewNamesInSearchPanel() {
      var data = vm.model.searchCriteria.crewType;
      vm.model.masterList.crewListInSearchPanel = [];
      vm.model.searchCriteria.crewName = null;

      if (data == null || data.crewTypeCode == null) {
        return;
      }
      var param = {};
      param.crewType = '';
      param.active = true;
      param.crewType = data.crewTypeCode;
      CommonMasterData.loadCrewList(param, function (response) {
        vm.model.masterList.crewListInSearchPanel = crewScheduleService
          .adaptCrewList(response);
      }, function () {
        console.log('Crew list retrieval error');
      });
    }

    function searchCrewNamesInCreateRequestPanel() {
      var data = vm.model.selectedBidRequest.crewTypeCode;
      vm.model.masterList.crewListInCreateReqPanel = [];
      vm.model.selectedBidRequest.crewName = null;

      if (data == null || data.crewTypeCode == null) {
        return;
      }
      var param = {};
      param.crewType = '';
      param.active = true;
      param.crewType = data.crewTypeCode;
      CommonMasterData.loadCrewList(param, function (response) {
        vm.model.masterList.crewListInCreateReqPanel = crewScheduleService
          .adaptCrewList(response);
      }, function () {
        console.log('Crew list retrieval error');
      });

    }

		function searchPatternNames(){

			vm.model.masterList.patternNames = [];
			vm.model.selectedBidRequest.patternName = null;

			if(vm.model.selectedBidRequest == null){
				return;
			}

			if(vm.model.selectedBidRequest.crewTypeCode == null ||
					vm.model.selectedBidRequest.crewTypeCode.crewTypeCode == null){
				return;
			}

			if(vm.model.selectedBidRequest.requestDate == null){
				return;
			}

			BiddingService.searchPatternNamesByCrewTypeAndReqDate(
				vm.model.selectedBidRequest,
				function(patternNames){
		    		vm.model.masterList.patternNames = patternNames;
				},
		    	function(error){
					MessageService.error(error);
		    	}
			);
		}

		function createNewRequest(){
			showLoader(true);
			BiddingService.createNewRequest(
					vm.model.selectedBidRequest,
					function(response){
					    if(response.success){
					       vm.model.selectedBidRequest = BiddingService.getNewBidRequest();
					       showLoader(false);

		                   if(vm.model.initialSearchDone){
		                	   searchBiddingsAfterApprove();
					       }

		                   vm.model.createPanelToggle = false;
		                   MessageService.success('Successfully saved the record!');
		               }else{
		                   MessageService.error(response.errors[0]);
		               }
					},
			    	function(error){
						MessageService.error(error);
			    	}
			);
		}

		function getBiddingReport(){
		    var url = CommonLogicService.getReportUrl('crew_bidding.rptdesign&__format=xls',getSearchParamMap());
		    vm.model.reportUrl = $sce.trustAsResourceUrl(url);
		    window.open(vm.model.reportUrl);

		}

		function getSearchParamMap(){
		    var searchParamMap = {};
		    searchParamMap["cycleId"] = vm.model.searchCriteria.cycle.cycleId;
		    searchParamMap["fleetType"]= vm.model.searchCriteria.fleetType !== null && !angular.isUndefined(vm.model.searchCriteria.fleetType)?vm.model.searchCriteria.fleetType.airCraftType:"";
		    searchParamMap["crewBase"]= vm.model.searchCriteria.crewBase !== null && !angular.isUndefined(vm.model.searchCriteria.crewBase)? vm.model.searchCriteria.crewBase.airPortCode :"";
		    searchParamMap["crewGroup"]= vm.model.searchCriteria.crewGroup !== null && !angular.isUndefined(vm.model.searchCriteria.crewGroup)? vm.model.searchCriteria.crewGroup.groupCode :"";
		    searchParamMap["cycleName"] = vm.model.searchCriteria.cycle.cycleName;
		    searchParamMap["crewTypeCode"] = vm.model.searchCriteria.crewType !== null && !angular.isUndefined(vm.model.searchCriteria.crewType)? vm.model.searchCriteria.crewType.crewTypeCode :"";
		    searchParamMap["crewId"] = vm.model.searchCriteria.crewId !== null && !angular.isUndefined(vm.model.searchCriteria.crewId)? vm.model.searchCriteria.crewId :"";
		    searchParamMap["reqType"] = vm.model.searchCriteria.reqType !== null && !angular.isUndefined(vm.model.searchCriteria.reqType) ? vm.model.searchCriteria.reqType.reqTypeCode : "";
		    return searchParamMap;
		}

		BiddingService.searchCycleMasterData(function(cycleMasterData) {
			vm.model.masterList.cycles = cycleMasterData;
		}, function(error) {
			MessageService.error(error);
		});

    CommonMasterData.getAircraftModels(function (airCraftList) {
      vm.model.masterList.fleetTypes = airCraftList;
    }, function () {
      console.log('Aircraft type retrieval error');
    });


    BiddingService.searchCrewBases(function(crewBases) {
			vm.model.masterList.crewBases = crewBases;
		}, function(error) {
			MessageService.error(error);
		});

		BiddingService.searchCrewGroups(function(crewGroups) {
			vm.model.masterList.crewGroups = crewGroups;
		}, function(error) {
			MessageService.error(error);
		});

		BiddingService.searchCrewTypes(
	    	 function(crewTypes){
    			 vm.model.masterList.crewTypes = crewTypes;
    		 },
    		 function(error){
    			 MessageService.error(error);
    		 }
	     );

		BiddingService.searchPatternDurationTypes(
		    	 function(durationTypes){
	    			 vm.model.masterList.durationTypes = durationTypes;
	    		 },
	    		 function(error){
	    			 MessageService.error(error);
	    		 }
		);

		BiddingService.searchPatternDepartureTypes(
		    	 function(departureTypes){
	    			 vm.model.masterList.departureTypes = departureTypes;
	    		 },
	    		 function(error){
	    			 MessageService.error(error);
	    		 }
		);

		BiddingService.searchRequestPriorities(
		    	 function(requestPriorities){
	    			 vm.model.masterList.requestPriorities = requestPriorities;
	    		 },
	    		 function(error){
	    			 MessageService.error(error);
	    		 }
		);

		setDefault();

		vm.openMaxBiddingSettingsPanel = function() {
			vm.model.searchPanelToggle = false;
			BiddingService.getMaxCrewBidding(function(response) {
				var details = [];
				details.maxCrewBiddingsDTOs = response;
				PopupManager.openModal('MAX_BIDDING_SETTINGS', details);
			}, function(error) {
				MessageService.error(error);
			});
		}

		function saveMaxCrewBiddingDetails(param){
			BiddingService.saveMaxCrewBiddingDetails(param,
				function(response){
				    if(response.success){
				    	PopupManager.closeModal('MAX_BIDDING_SETTINGS');
	                    MessageService.success('Successfully saved the details!');
	               }else{
	                    MessageService.error(response.errors[0]);
	               }
				},
		    	function(error){
					if(error)
						MessageService.error(error[0]);
					else
						MessageService.error("error");
		    	});
		}

  }
}());
